import axios from '../utils/request';

// 列表
export const getFacesList = params => {
  return axios.get('/TemporaryUsers', {
    params,
  });
};
// 未支付订单
export const unpaidOrder = params => {
  return axios.get('/TemporaryUsers/unpaidOrder', {
    params,
  });
};
// 添加
export const addEntranceguard = data => {
  return axios.post('/TemporaryUsers', data);
};
// 删除
export const delEntranceguard = params => {
  return axios.delete('/TemporaryUsers', { params });
};
// 支付
export const payment = data => {
  return axios.post('/TemporaryUsers/pay', data);
};

// 优惠券
// 列表
export const getCouponList = params => {
  return axios.get('/TemporaryUsers/coupon/log', {
    params,
  });
};
// 领取
export const receiveCoupon = data => {
  return axios.post('/TemporaryUsers/coupon', data);
};
// 详情
export const getCouponDetail = params => {
  return axios.get('/TemporaryUsers/coupon/show', {
    params,
  });
};
// 订单可使用
export const getAvailableCoupon = params => {
  return axios.get('/TemporaryUsers/coupon_available', {
    params,
  });
};
export const getVersion = params => {
  return axios.get('/TemporaryUsers/version', {
    params,
  });
};

// 订单列表
export const getOrderList = params => {
  return axios.get('/TemporaryUsers/order_list', {
    params,
  });
};

// 开票
export const invoiceVerify = params => {
  return axios.get('/TemporaryUsers/invoice_verify', { params });
};

// 开票
export const invoice = data => {
  return axios.post('/TemporaryUsers/invoice', data);
};
